module.exports = __webpack_public_path__ + "img/1.370fc14f.png";